function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourcePoolAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 172 172",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 172V0h172v172z",
    style: {
      fill: "none",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34.507 10.779-23.291 10.75v129l23.291 10.75m102.983-150.5 23.293 10.75v129l-23.292 10.75",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#7a7a7a",
      strokeWidth: 10.74999046,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7a7a7a"
    },
    d: "M33 38H19.271c1.649 5.999-.566 6.859-10.271 6.859V48h33v-3.141c-9.705 0-10.656-.857-9.005-6.859",
    transform: "translate(25.08 29.957) scale(2.43666)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a1a2"
    },
    d: "M46.98 2H2.719C1.215 2 .002 3.345.002 4.847v31.329c0 1.493 1.213 2.823 2.717 2.823H46.98c1.501 0 3.021-1.33 3.021-2.823V4.847C50.001 3.341 48.481 2 46.98 2",
    transform: "translate(25.08 29.957) scale(2.43666)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#fff"
    },
    d: "m47.011 2.003-.031-.002H2.718C1.214 2.001.001 3.345.001 4.848v31.328C.001 37.67 1.214 39 2.718 39h1.053z",
    transform: "translate(25.08 29.957) scale(2.43666)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59b4d9"
    },
    d: "M46 6v29H4V6z",
    transform: "translate(25.08 29.957) scale(2.43666)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a1a2"
    },
    d: "M9 45h33v3H9z",
    transform: "translate(25.08 29.957) scale(2.43666)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8d432"
    },
    d: "M25.518 4.095a.71.71 0 1 1-1.42 0 .71.71 0 0 1 1.42 0",
    transform: "translate(25.08 29.957) scale(2.43666)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M25.028 19.394a.278.278 0 0 1-.134-.038l-8.804-5.082a.267.267 0 0 1 0-.461l8.751-5.049a.268.268 0 0 1 .263 0l8.807 5.084a.264.264 0 0 1 .131.23.262.262 0 0 1-.131.23l-8.748 5.048a.273.273 0 0 1-.135.038",
    transform: "translate(25.08 29.957) scale(2.43666)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#fff"
    },
    d: "M23.763 31.746a.251.251 0 0 1-.134-.036l-8.778-5.066a.26.26 0 0 1-.136-.231V16.247c0-.096.051-.183.136-.231a.263.263 0 0 1 .268 0l8.777 5.064a.28.28 0 0 1 .13.233v10.166a.272.272 0 0 1-.13.231.28.28 0 0 1-.133.036",
    transform: "translate(25.08 29.957) scale(2.43666)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#fff"
    },
    d: "M26.248 31.746a.287.287 0 0 1-.138-.036.27.27 0 0 1-.129-.231V21.377c0-.094.051-.182.129-.231l8.777-5.064a.26.26 0 0 1 .264 0 .263.263 0 0 1 .135.23v10.101a.261.261 0 0 1-.135.231l-8.774 5.066a.239.239 0 0 1-.129.036",
    transform: "translate(25.08 29.957) scale(2.43666)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcePoolAzure);
export default __webpack_public_path__ + "static/media/resourcePoolAzure.fd4f57b1555101f1face07d78448b2f7.svg";
export { ForwardRef as ReactComponent };